export default {
	SET_USER(state, user) {
		// let emailParts = user.email.split("@")
		// let userDomain = emailParts[1]
		// state.authenticated = !!user && (userDomain == '@jahnelgroup.com')

		state.authenticated = !!user;
		state.user = {
			email: user ? user.email : null,
			displayName: user ? user.displayName : null,
			photoURL: user ? user.photoURL : null,
		};
	},
	SET_AUTHORIZED(state, user) {
		// Check if the user is logged in
		if (!user) {
			state.authorized = false;
		} else {
			let emailParts = user.email.split("@");
			let userDomain = emailParts[1];
			state.authorized = !!user && (userDomain == "jahnelgroup.com");
		}
	},
	SET_ADMINISTRATOR(state, payload) {
		// set the administrator state to false
		// if user's email is in the administrator list
		// then set the administrator state to true 
		state.administrator = false;
		let administratorsQuery = payload.administratorsEmail.orderByChild("email");
		administratorsQuery.once("value")
			.then(function (snapshot) {
				snapshot.forEach(function (childSnapshot) {
					let childData = childSnapshot.val();
					if (childData.email == payload.user.email) {
						state.administrator = true;
					}
				});
			});
	},
	SET_TOKEN(state, payload) {
		state.token = payload;
	},
	SET_SELECTED_PERSON_KEY(state, payload) {
		state.selectedPersonKey = payload;
	},
	SET_SELECTED_PERSON_VEHICLES(state, payload) {
		state.selectedPersonVehicles = payload;
	},
	SET_PEOPLE(state, payload) {
		state.people = payload;
	},
	SET_TECHNOLOGY(state, payload) {
		state.technology = payload;
	},
	SET_SKILLS_RATING_BY_TECHNOLOGY(state, payload) {
		state.skillsRatingByTechnology = payload;
	},
	SET_PERSON(state, payload) {
		// console.log("payload: ", payload)
		state.person = {
			email: payload.email,
			fName: payload.fName,
			lName: payload.lName,
			nName: payload.nName,
			title: payload.title,
			phone1: payload.phone1,
			phone2: payload.phone2,
			email1: payload.email1,
			email2: payload.email2,
			street: payload.street,
			city: payload.city,
			zip: payload.zip,
			emergencyName: payload.emergencyName,
			emergencyRelationship: payload.emergencyRelationship,
			emergencyPhone1: payload.emergencyPhone1,
			emergencyPhone2: payload.emergencyPhone2,
			vehicleMakeModel: payload.vehicleMakeModel,
			licensePlateNumber: payload.licensePlateNumber,
			id: payload.id,
			birthDate: payload.birthDate,
			startDate: payload.startDate,
			status: payload.status,
			group: payload.group,
			shareBirthDate: payload.shareBirthDate,
			teamPage: payload.teamPage,
			kelmarId: payload.kelmarId,
			onsipExtension: payload.onsipExtension
		};
	},
	SET_SELECTED_PERSON_IS_USER(state) {
		if (state.person.email == state.user.email) {
			state.selectedPersonIsUser = true;
		} else {
			state.selectedPersonIsUser = false;
		}
	},
	SET_GROUPS(state, payload){
		state.groups = payload;
	},
	SET_SELECTED_GROUP_KEY(state, payload) {
		state.selectedGroupKey = payload;
	},
	SET_SELECTED_GROUP(state, payload) {
		state.selectedGroup = payload;
	},
	SET_SELECTED_GROUP_MEMBERS(state, payload) {
		state.selectedGroupMembers = payload;
	},
	SET_MEMBERSHIPS(state, payload) {
		state.memberships = payload;
	},
	SET_SELECTED_MEMBER_KEY(state, payload) {
		state.selectedMemberKey = payload;
	},
	SET_SELECTED_MEMBER(state, payload) {
		state.selectedMember = payload;
	},
	SET_SELECTED_MEMBERSHIPS(state, payload) {
		state.selectedMemberships = payload;
	},
	SET_SELECTED_SLACK_MEMBER(state, payload) {
		state.selectedSlackMember = payload;
	},
	SET_SELECTED_SLACK_MEMBERSHIPS(state, payload) {
		state.selectedSlackMemberships = payload;
	},
	SET_BIRTHDAYS_THIS_MONTH(state, payload) {
		state.birthdaysThisMonth = payload;
	},
	SET_ANNIVERSARIES_THIS_MONTH(state, payload) {
		state.anniversariesThisMonth = payload;
	},
	SET_TOGGL_PROJECTS(state, payload) {
		state.togglProjects = payload;
	},
	SET_PROJECTS_MANAGEMENT_OVERVIEW(state, payload) {
		state.projectsManagementOverview = payload;
	},
	SET_PROJECTS_MANAGEMENT_DETAILS(state, payload) {
		state.projectsManagementDetails = payload;
	},
	SET_SELECTED_PROJECT_KEY(state, payload) {
		state.selectedProjectKey = payload;
	},
	SET_PROJECT(state, payload) {
		state.project = payload;
	},
	SET_SKILLS_RATING_BY_PERSON(state, payload) {
		state.skillsRatingByPerson = payload;
	},
	SET_SELECTED_PERSON_SKILLS_RATING(state, payload) {
		state.selectedPersonSkillsRating = payload;
	}
};



// WEBPACK FOOTER //
// ./src/store/mutations.js